import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsertEmoji = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(-4)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 24,
			rx: 2
		}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M2 0h20c1.105 0 2 .895 2 2v20c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z",
			transform: "translate(4)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#475464",
			fillRule: "nonzero",
			d: "M11.992 4C7.576 4 4 7.584 4 12s3.576 8 7.992 8C16.416 20 20 16.416 20 12s-3.584-8-8.008-8zM12 18.4c-3.536 0-6.4-2.864-6.4-6.4 0-3.536 2.864-6.4 6.4-6.4 3.536 0 6.4 2.864 6.4 6.4 0 3.536-2.864 6.4-6.4 6.4zm2.8-7.2c.664 0 1.2-.536 1.2-1.2 0-.664-.536-1.2-1.2-1.2-.664 0-1.2.536-1.2 1.2 0 .664.536 1.2 1.2 1.2zm-5.6 0c.664 0 1.2-.536 1.2-1.2 0-.664-.536-1.2-1.2-1.2-.664 0-1.2.536-1.2 1.2 0 .664.536 1.2 1.2 1.2zm2.8 5.6c1.824 0 3.374-1.335 4-3.2H8c.626 1.865 2.176 3.2 4 3.2z",
			transform: "translate(4)"
		})] })]
	})
});
export default SvgInsertEmoji;
